<template>
  <div class="row android-develop px-4">
    <div class="col-lg-6 col-md-12">
      <div class="personal">
        <h3>{{selectedTrack.name}}</h3>
        <p>
          {{selectedTrack.paragraph}}
        </p>
        <div class="here">
          <p>Here are somethings you will be learning in this course</p>
        </div>
        <ul>
          <li>Here are somethings you will be learning in this course</li>
          <li>Here are somethings you will be learning in this course</li>
          <li>Here are somethings you will be learning in this course</li>
          <li>Here are somethings you will be learning in this course</li>
          <li>Here are somethings you will be learning in this course</li>
          <li>Here are somethings you will be learning in this course</li>
        </ul>
      </div>
      <p class="best">
        <b class="tools">Tools & Softwares</b> needed for this course : android
        studio, Github, Laptop etc
      </p>
      <div class="reacher">
        <a href="#contact">Contact us</a>
      </div>
    </div>
    <div class="col-lg-6 col-md-12">
      <div class="key">
        <img src="../../assets/Images/keyboard.png" alt="" class="img-fluid" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        selectedTrack: Object
    }
};
</script>



<style scoped>
.img-1 img,
.img-4 img {
  height: 421px;
  border-radius: 12px;
}
.img-2 img,
.img-3 img {
  height: 203px;
  border-radius: 12px;
}
.img-5 img,
.img-6 img {
  width: 262px;
  height: 203px;
  border-radius: 12px;
}
.img-6,
.img-3 {
  margin-top: 1rem;
}
img:hover {
  opacity: 0.8;
}
.onsite h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #ff6600;
}
.tracks h6 {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  color: #000000;
}
.personal h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 150%;
  color: #ff6600;
}
.experience small {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #ff6600;
}
.our-service h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #1f1f1f;
  margin-bottom: 3rem;
}
/* for p tags */
.read p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}
.tracks p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}
.developers small {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #ff6600;
}

.reacher a {
  background: #ff6600;
  border-radius: 8px;
  text-decoration: none;
  padding: 11px 48px;
  color: #ffffff;
  transition: 1s ease-in-out;
}

.reacher a:hover,
.reacher a:focus {
  background: transparent;
  color: #ff6600;
  border: 3px solid #ff6600;
  transition: 1s ease-in-out;
}

.developers p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}

.personal p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 184%;
  color: #595959;
  margin-right: 112px;
}
.views p {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  color: #595959;
  margin-bottom: 3rem;
}

.here p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #4d4d4d;
  margin-top: 17px;
}

.tools {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #335ca6;
}
.best {
  font-size: 14px;
  margin-top: 2.1rem;
}
/* for colors */
.train {
  color: #ffffff;
}

.developers {
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.5s ease-out;
}

.ram {
  margin-bottom: 1.5rem;
}

.android-develop {
  background: #ffffff;
  margin-bottom: 2.7rem;
}

.developers:hover,
.developers:focus {
  border: 2px solid #ff6600;
  background: rgba(136, 203, 84, 0.1);
}
.experience {
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.5s ease-out;
}

.experience:hover,
.experience:focus {
  border: 2px solid #ff6600;
  background: rgba(136, 203, 84, 0.1);
}
.more-services {
  background: #ffffff;
  width: 100%;
  padding: 3.5rem 0;
}
/* for a tags */
.reacher {
  margin-top: 2.5rem;
}

.get-us a {
  text-decoration: none;
  padding: 8px 45px;
  border: 3px solid #ff6600;
  border-radius: 8px;
  color: #ff6600;
  transition: 1s ease-in-out;
}
.get-us a:hover,
.get-us:focus {
  background: #ff6600;
  color: #fff;
}
/* for margins */
.available {
  margin-top: 5rem;
}
.reversing {
  padding: 4rem 0;
}

.read {
  margin-top: 1.4rem;
}
.experience {
  margin-bottom: 2rem;
}
.views {
  margin-bottom: 2.5rem;
}
.get-us {
  margin-top: 3rem;
}

.key {
  margin-top: 2rem;
}

.android-develop {
  padding: 3.5rem 1rem;
}

/* for responsiveness */
@media screen and (max-width: 768px) {
  .training {
    /* width: 100%; */
    height: 360px;
  }
  /* for h tags */
  .train h1 {
    font-size: 46px;
  }

  /* for tags */
  .train p {
    padding: 0 202px;
  }
  .read p {
    margin-right: 0px;
    font-size: 16px;
  }

  .read {
    text-align: center;
  }
  .get-us {
    position: relative;
    top: 619px;
    display: flex;
    justify-content: center;
  }
  .onsite h3 {
    text-align: center;
    margin-bottom: -40px;
  }
  .oncheck img {
    margin-right: auto;
    margin-left: auto;
    display: block;
    height: 485px;
    width: 639px;
    margin-top: -45px;
  }
  .get-us {
    top: 543px;
  }
  .tracks {
    margin-top: 10rem;
  }
  .skip,
  .experience {
    margin-bottom: 1.8rem;
  }
  .developers:hover {
    border: none;
    background: none;
  }
  .experience:hover {
    border: none;
    background: none;
  }

  .img-5,
  .img-4 {
    margin-top: 1.5rem;
  }
  .img-2 img,
  .img-3 img,
  .img-5 img,
  .img-6 img {
    width: 333px;
  }

  .personal {
    text-align: center;
  }

  .personal p {
    margin: 0px 0px;
  }
  .here {
    margin: 0px 66px;
  }
  .key img {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  ul {
    list-style: none;
  }
  .best {
    text-align: center;
  }
  .reacher {
    display: flex;
    justify-content: center;
  }
  .android-develop {
    background-color: transparent;
  }
}

@media screen and (max-width: 425px) {
  .my-program {
    width: 631px;
    background: rgb(8, 2, 2);
  }
  .train p {
    padding: 0px 108px;
  }

  .training {
    width: 631px;
  }

  .developers,
  .experience {
    margin: 0px 20px;
    text-align: center;
  }
  .experience {
    margin-bottom: 1.8rem;
  }
  .experience p {
    padding: 0 34px;
    font-size: 23px;
  }
  .developers p {
    padding: 0 34px;
    font-size: 23px;
  }

  .developers small {
    font-size: 26px;
  }

  .experience small {
    font-size: 26px;
  }

  .experience,
  .developers {
    background: none;
  }
  .img-1 img,
  .img-4 img,
  .img-2 img,
  .img-3 img,
  .img-5 img,
  .img-6 img {
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 480px;
    height: 445px;
  }
  .img-6,
  .img-3,
  .img-2,
  .img-4,
  .img-5 {
    margin-top: 37px;
  }

  .views {
    text-align: center;
  }

  .tracks {
    text-align: center;
  }

  .oncheck img {
    width: 537px;
  }
}

@media screen and (max-width: 375px) {
}
@media screen and (max-width: 320x) {
}
</style>
